import { LitEntity, html, css } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';
import '../../common/bn-svg-icon';
import './export-bins-modal';

class ExportBinsButton extends LitEntity {
  static get properties() {
    return {
      showModal: { type: Boolean },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      bn-svg-icon {
        margin-right: .25em;
      }
    `];
  }

  render() {
    return html`
      <button class="button button--contained" @click="${this._onClick}">
        <bn-svg-icon name="FileDocumentArrowRight"></bn-svg-icon> Export
      </button>

      <export-bins-modal
        .href="${this.href}"
        ?hide="${!this.showModal}"
        @close="${() => this.showModal = false}"
      ></export-bins-modal>
    `;
  }

  _onClick(e) {
    e.stopPropagation();
    this.showModal = true;
  }
}

window.customElements.define('export-bins-button', ExportBinsButton);
